import DialogContent from '@material-ui/core/DialogContent';
import { MapperTypeCompanyLevel } from 'entities/MapperType';
import React, { useEffect } from 'react';
import {
	TextInput,
	required,
} from 'react-admin';
import {useForm, useFormState} from 'react-final-form';

import { PassProps } from '../../../components/_helpers/PassProps';
import { GridForm, GridInput } from '../../../components/GridForm';
import { MapperTypeSelect } from '../../../components/inputs/MapperTypeSelect';
import { getOptionalKeysByType, predefinedByType } from '../../../utils/mapper';
import { MapperDataInput, MapperDataInputPredefined } from '../../mappers/components/MapperDataInput';

export const AddEditMapperBody = ({form, ...rest}) => {
	const [isPredefined, setIsPredefined] = React.useState(false);
	const [optionalKeys, setOptionalKeys] = React.useState();
	const { values } = useFormState();

	useEffect(()=>{		
		const predefinedData = predefinedByType[values["type"]];
		if (predefinedData) {
			if(!rest?.record?.data){
				form.change('data', predefinedData);
			}
			setIsPredefined(true);
		} else {
			form.change('data', []);
			setIsPredefined(false);
		}
		const optKeys = getOptionalKeysByType(values["type"]);
		setOptionalKeys(optKeys);		
	}, [values["type"]]);	
	
	return (
		<PassProps component={DialogContent} childPropKeys={["resource", "record"]} resource="customer-companies-mappers" {...rest}>
			<GridForm>
				<GridInput xs={6} component={TextInput} source="name" label="resources.mappers.fields.name" validate={required()}/>
				<GridInput xs={6} component={MapperTypeSelect} source="type" label="resources.mappers.fields.type" 
					enumObj={MapperTypeCompanyLevel} disabled={rest?.record || rest.defaultValue} defaultValue={rest.defaultValue} validate={required()} />
				<GridInput xs={12} source="data" label="resources.mappers.fields.data">
					{isPredefined ? <MapperDataInputPredefined optionalKeys={optionalKeys} formData={values}/> : <MapperDataInput />}
				</GridInput>
			</GridForm>
		</PassProps>
	);
};
